module.exports = __webpack_public_path__ + "img/ltkbaby-1x.a229b32.jpg";